module.exports = __webpack_public_path__ + "img/分区05.721160ec.png";